module.exports = __webpack_public_path__ + "img/Cooling_Load_vs_COP.d7e9e28b.png";